import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

// Context
import { OEMContext } from "@DataPages/context/oem/OEMContext";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Components
import OEMDataLayer from "@DataPages/components/OEM/OEMDataLayer";
import PageLayer from "@Layouts/views/PageLayer";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/dataPages/OemDataIcon.svg";

export default function OEMDataView() {
	const location = useSelector((state) => state.location.location);
	const [franchise, setFranchise] = useState("");
	const value = useMemo(() => ({ franchise, setFranchise }), [franchise]);

	useEffect(() => {
		setFranchise(location?.franchises?.[0]);

		return () => {
			setFranchise("");
		};
	}, [location]);

	return (
		<OEMContext.Provider value={value}>
			<PageLayer
				title="OEM Data"
				icon={
					<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
						<SvgIcon className="text-[var(--medium-pink-color)] !text-[26px]" viewBox="0 0 21 21" component={Icon} />
					</Stack>
				}
			>
				<OEMDataLayer />
			</PageLayer>
		</OEMContext.Provider>
	);
}
